import { useContext } from "react";
import { useFormikContext } from "formik";
import * as Yup from "yup";
import { Paper, Stack, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { Branch } from "@/types/branch";
import { pick } from "lodash";

export type IBranchForm = {
  branch: Pick<Branch, "id" | "title" | "location" | "whatsapp"> | null;
};

export const BranchFormSchema = Yup.object().shape({
  branch: Yup.object()
    .shape({
      id: Yup.string().required(),
    })
    .nullable()
    .required("Debes seleccionar una sucursal."),
});

export const branchFormInitialValues: IBranchForm = {
  branch: null,
};

export const branchFormFields = Object.keys(branchFormInitialValues);

export const onSubmitBranchForm = async (values: IBranchForm) => {
  const draft = pick(values, branchFormFields);
  return draft;
};

const BranchForm = () => {
  const formik = useFormikContext<IBranchForm>();
  const { organization, branch } = useContext(WebsiteContext);

  const orgBranch = branch?.find((b) => b.id === organization?.mainBranch) || null;

  const branchId = formik.values.branch?.id || "";

  const handleBranchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const branchId = event.target.value;
    const selected = branch?.find((b) => b.id === branchId) || null;
    const payload = selected ? pick(selected, ["id", "title", "location", "whatsapp"]) : null;

    formik.setFieldValue("branch", payload);
  };

  return (
    <Stack spacing={2}>
      {branch && branch.length > 0 ? (
        <Typography variant="h6" gutterBottom>
          Escoge la sucursal más cercana a ti
        </Typography>
      ) : (
        <Typography variant="h6" gutterBottom>
          La orden se realizará en la dirección principal
        </Typography>
      )}
      <RadioGroup name="branch" value={branchId} onChange={handleBranchChange}>
        {orgBranch ? (
          <Paper sx={{ p: 2, mb: 1 }}>
            <FormControlLabel
              value={orgBranch.id}
              control={<Radio />}
              label={
                <Stack>
                  <Typography variant="subtitle1">{orgBranch.title}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {orgBranch.location?.address}
                  </Typography>
                </Stack>
              }
            />
          </Paper>
        ) : branch && branch.length > 0 ? (
          branch.map((b) => (
            <Paper key={b.id} sx={{ p: 2, mb: 1 }}>
              <FormControlLabel
                value={b.id}
                control={<Radio />}
                label={
                  <Stack>
                    <Typography variant="subtitle1">{b.title}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {b.location?.address}
                    </Typography>
                  </Stack>
                }
              />
            </Paper>
          ))
        ) : (
          <Paper sx={{ p: 2, mb: 1 }}>
            <FormControlLabel
              value={organization?.address || ""}
              control={<Radio />}
              label={
                <Stack>
                  <Typography variant="subtitle1">Dirección principal</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {organization?.address}
                  </Typography>
                </Stack>
              }
            />
          </Paper>
        )}
      </RadioGroup>
    </Stack>
  );
};

export default BranchForm;
